import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");


export const getListCommande = createAsyncThunk("commande/listCommande", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/listCommande", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const commande = await response.json();
  return commande;
});

export const getListCommandeSage = createAsyncThunk("commande/listCommandeSage", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/listCommandeSage", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const commande = await response.json();
  return commande;
});

export const fetchGrossisteCommande = createAsyncThunk("commande/fetchGrossisteCommande", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/fetchGrossisteCommande", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const commande = await response.json();
  return commande;
});

export const allCommande = createAsyncThunk("commande/allCommande", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/allCommande", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const commande = await response.json();
  return commande;
});

export const countListCommande = createAsyncThunk("commande/countListCommande", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/countListCommande", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const commande = await response.json();
  return commande;
});


export const getallfile = createAsyncThunk("commande/getallfile", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getallfile", {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});

export const deleteFileD = createAsyncThunk("commande/deleteFileD", async (file) => {

  const response = await fetch(Configuration.BACK_BASEURL + "commande/deleteFileD/" + file, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});
export const thumbnail = createAsyncThunk("commande/thumbnail", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/thumbnail", {
    method: "Post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});

export const getCommandeById = createAsyncThunk("commande/getCommandeById", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getCommandeById/" + id, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});

export const getCommandeByIdSage = createAsyncThunk("commande/getCommandeByIdSage", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getCommandeByIdSage/" + id, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});

export const historiqueCommande = createAsyncThunk("commande/historiqueCommande", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/historiqueCommande/" + id, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});

export const historiqueCommandeParRef = createAsyncThunk("commande/historiqueCommandeParRef", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/historiqueCommandeParRef/" + action.idCmd + "/" + action.idUser, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});

export const getCommandeByIdParRef = createAsyncThunk("commande/getCommandeByIdParRef", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getCommandeByIdParRef/" + action.idCmd + "/" + action.idUser, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});

export const postSageCommande = createAsyncThunk("commande/postSageCommande", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/postSageCommande/" + action.id_site + '/' + action.idCmd, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});


export const getCommentaireCmd = createAsyncThunk("commande/getCommentaireCmd", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getCommentaireCmd/" + action.idCmd, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});

export const updateCmd = createAsyncThunk("commande/updateCmd", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/updateCmd", {
    method: "Post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});


//getDetailCommande
export const getDetailCommande = createAsyncThunk("commande/getDetailCommande", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getDetailCommande/" + id, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});

export const getDetailCommandeSage = createAsyncThunk("commande/getDetailCommandeSage", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getDetailCommandeSage/" + id, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});

//getDetailCommandeParRef
export const getDetailCommandeParRef = createAsyncThunk("commande/getDetailCommandeParRef", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getDetailCommandeParRef/" + action.idCmd + "/" + action.idUser, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});

export const extractionsCommande = createAsyncThunk(
  "commande/extractionsCommande",
  async (formData) => {
    const response = await fetch(Configuration.BACK_BASEURL + "commande/extractionsCommande", {
      method: "POST",
      headers: {
        Accept: "application/*",
        "x-access-token": token,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Failed to extract commande");
    }

    return response.json();
  }
);


//upload commande file
export const saveFile = createAsyncThunk("commande/saveFile", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/saveFile", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const commande = await response.json();
  return commande;
});


export const saveFile64 = createAsyncThunk("commande/saveFile64", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/saveFile64", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});

export const saveFileContraste = createAsyncThunk("commande/saveFileContraste", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/saveFileContraste", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const commande = await response.json();
  return commande;
});

export const sendFileImage = createAsyncThunk("commande/sendFileImage", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/sendFileImage", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});

//getFile
export const getFileCommandeRef = createAsyncThunk("commande/getFileRef", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getFileRef/" + action.file + "/" + action.idUser, {
    method: "GET",
    responseType: "blob",
    headers: {
      'x-access-token': token,
    },
  }).then(response => response.blob())
    .then(function (myBlob) {
      return ((myBlob))
    })
    .catch((error) => {
      console.log(error);
    })
  const files = await response;
  return files;
});


//getFile
export const getFileCommande = createAsyncThunk("commande/getFile", async (file) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getFile/" + file, {
    method: "GET",
    responseType: "blob",
    headers: {
      'x-access-token': token,
    },
  }).then(response => response.blob())
    .then(function (myBlob) {
      return ((myBlob))
    })
    .catch((error) => {
      console.log(error);
    })
  const files = await response;
  return files;
});

export const verifCmd = createAsyncThunk("commande/verifCommande", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/verifCommande", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});

export const getNumCommandGros = createAsyncThunk("commande/getNumCommandGros", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getNumCommandGros", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});
export const commandeAddedList = createAsyncThunk("commande/commandeAddedList", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/commandeAddedList", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});

export const commandeAdded = createAsyncThunk("commande/addCommande", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/addCommande", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});
export const commandeAddedExcel = createAsyncThunk("commande/commandeAddedExcel", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/commandeAddedExcel", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});

export const ChangeEtatCmd = createAsyncThunk("commande/ChangeEtatCmd", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/ChangeEtatCmd", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});


export const getLivEtatCommande = createAsyncThunk("commande/getLivEtatCommande", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/getLivEtatCommande", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});

export const cheeckProduit = createAsyncThunk("commande/cheeckProduit", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/cheeckProduit", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const commande = await response.json();
  return commande;
});
export const deleteCmd = createAsyncThunk("commande/delete", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "commande/delete/" + id, {
    method: "delete",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const commande = await response.json();
  return commande;
});
const commandeSlice = createSlice({
  name: "commande",
  initialState: {
    getListCommande: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {



  },
});

export default commandeSlice.reducer;
